import { Route, Router } from 'react-router';
import React from 'react';

import {
  Breakpoints,
  Container,
  ContainerGutter,
  ContainerPadding,
  IntegratorRoot,
  Layout,
  ThemeProvider,
} from '@vw-marketing/us-components';
import {
  FaContentServiceV1,
  Content,
} from '@volkswagen-onehub/fa-content-service';
import { FeatureAppLoader } from '@feature-hub/react';
import { History } from 'history';

import { appsUMD, appsCommonsJS } from './app-constants';
import {
  contentFeatureAppMap,
  getConfigsFeatureApp,
} from './feature-app-helpers';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';
import Ngw6AppRender from './components/ngw6-app-render';

export interface IntegratorProps extends ModelOverviewIntegratorOptions {
  readonly history: History;
}

export function Integrator({
  baseUrl,
  history,
  ssr,
  featureAppName = 'default',
  ...props
}: IntegratorProps): JSX.Element {
  const featureAppConfig = getConfigsFeatureApp({
    ...props,
    featureAppName,
  });

  return (
    <IntegratorRoot>
      <ThemeProvider>
        <Layout
          appearance={{
            [Breakpoints.default]: [
              { name: '.', columns: 0 },
              { name: 'a', columns: 24 },
              { name: '.', columns: 0 },
            ],
            [Breakpoints.b960]: [
              { name: '.', columns: 2 },
              { name: 'a', columns: 20 },
              { name: '.', columns: 2 },
            ],
          }}
          allowOverflowingContent
        >
          <Container
            wrap="always"
            padding={{
              top: ContainerPadding.static0,
              bottom: ContainerPadding.static350,
            }}
            gutter={ContainerGutter.static500}
          >
            <Router history={history}>
              <Route
                path="/"
                exact
                render={() => (
                  <FeatureAppLoader
                    featureAppId="ngw6fa"
                    baseUrl={baseUrl}
                    src={appsUMD[featureAppName]}
                    serverSrc={ssr ? appsCommonsJS[featureAppName] : undefined}
                    config={featureAppConfig}
                    beforeCreate={({ featureServices }) => {
                      const content: Content =
                        contentFeatureAppMap[featureAppName];
                      if (content) {
                        (featureServices[
                          'fa-content-service'
                        ] as FaContentServiceV1).content = content;
                      }
                    }}
                  />
                )}
              />
              <Route path="/application-render/:appId">
                <Ngw6AppRender isSsr={ssr} baseUrl={baseUrl} {...props} />
              </Route>
            </Router>
          </Container>
        </Layout>
      </ThemeProvider>
    </IntegratorRoot>
  );
}
